<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"> </router-view>
  </div>
</template>

<script>
export default {};
</script>
<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  /* overflow: hidden; */
  background: rgba(238, 244, 244, 1);
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* overflow-y: auto; */
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
.hong::before {
  display: none !important;
}
.hong .van-field__error-message {
  display: none !important;
}
.van-field__control::placeholder {
  color: #b3b5b9 !important;
}
.tishi {
  font-size: 14px;
  color: red;
  overflow: hidden;
}
.tishi .span1 {
  float: left;
  width: 20%;
}
.tishi .span2 {
  float: left;
  width: 80%;
}
.custom-eye_icon{
  font-size: 16px !important;
    line-height: inherit !important;
    padding-right: 20px !important;
}
.custom-down__icon{
  color: black !important;
}
</style>
